import { useEffect, useRef } from 'react';
import { Notice, toast } from '@/components/ui';
import { useT } from '@/i18n';
import { useOptionalApp } from '@/lib/auth/app-context';
import { useFormat } from '@/lib/format/useFormat';
import { useOnline } from '@/lib/online';

export function Banners() {
  const t = useT();
  const online = useOnline();
  const fmt = useFormat();
  const school = useOptionalApp()?.school;
  const wasOffline = useRef(false);
  // Sent to owners, managers and accountants only.
  const sub = school?.subscription;
  const renewal = sub && (sub.state === 'ENDING' || sub.state === 'GRACE') && school?.status !== 'READ_ONLY' ? sub : null;

  useEffect(() => {
    if (!online) wasOffline.current = true;
    else if (wasOffline.current) {
      wasOffline.current = false;
      toast.success(t('shell.backOnline'));
    }
  }, [online, t]);

  if (online && school?.status !== 'READ_ONLY' && !renewal) return null;
  return (
    <div className="flex flex-col gap-2 px-4 pt-4 sm:px-8 print:hidden">
      {!online ? (
        <Notice tone="warning" role="status">
          {t('shell.offlineBanner')}
        </Notice>
      ) : null}
      {school?.status === 'READ_ONLY' ? (
        <Notice tone="warning">{sub?.state === 'EXPIRED' ? t('shell.subscriptionEnded') : t('shell.readOnlyBanner')}</Notice>
      ) : null}
      {renewal ? (
        <Notice tone={renewal.state === 'GRACE' ? 'danger' : 'warning'} role="status">
          {renewal.state === 'GRACE'
            ? t('shell.subscriptionGrace', { date: fmt.date(renewal.endsOn, 'medium'), readOnly: fmt.date(renewal.readOnlyFrom, 'medium') })
            : renewal.daysLeft === 0
              ? t('shell.subscriptionEndsToday')
              : t('shell.subscriptionEnding', { n: fmt.count(renewal.daysLeft ?? 0, 'day'), date: fmt.date(renewal.endsOn, 'medium') })}
        </Notice>
      ) : null}
    </div>
  );
}
